// You can write more code here

import Duelist from '@/game/GameComponents/PhaserGame/Dueling/Duelist';
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import EventsManager from '@/game/GameComponents/PhaserGame/Managers/EventsManager';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { HorizontalLayoutGroup } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/HorizontalLayoutGroup';
import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import HeartContainer from './HeartContainer';

export interface DuelistUIData {
  duelist: Duelist;
  duelistIndex: number;
}

/* START OF COMPILED CODE */

export default class DuelistHealthBar extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // mainContainer
    const mainContainer = scene.add.container(16, 120);
    this.add(mainContainer);

    // duelistHealthBar
    const duelistHealthBar = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      64,
      16,
      4,
      4,
      4,
      4,
    );
    duelistHealthBar.scaleX = 4;
    duelistHealthBar.scaleY = 4;
    duelistHealthBar.setOrigin(0, 0);
    mainContainer.add(duelistHealthBar);

    // heartContainer
    const heartContainer = scene.add.container(0, 32);
    mainContainer.add(heartContainer);

    this.duelistHealthBar = duelistHealthBar;
    this.heartContainer = heartContainer;
    this.mainContainer = mainContainer;

    /* START-USER-CTR-CODE */
    this.hearts = [];
    /* END-USER-CTR-CODE */
  }

  private duelistHealthBar: Phaser.GameObjects.NineSlice;
  private heartContainer: Phaser.GameObjects.Container;
  private mainContainer: Phaser.GameObjects.Container;
  public side: string = 'left';

  /* START-USER-CODE */
  hearts: HeartContainer[];
  duelistUIData: DuelistUIData | null = null;
  layoutGroup?: HorizontalLayoutGroup;

  awake(data: DuelistUIData) {
    this.duelistUIData = data;
    if (this.duelistUIData == null) return;
    this.duelistUIData.duelist.onDuelistHpModified = this.refresh.bind(this);
    this.hearts = [];

    const { duelist } = this.duelistUIData;

    const layoutMargin = { x: this.side === 'left' ? 8 : -8, y: 0 };
    this.layoutGroup = new HorizontalLayoutGroup({
      parent: this.heartContainer,
      origin: new Phaser.Math.Vector2(layoutMargin.x, layoutMargin.y),
      elementDist: 36,
      align: this.side as 'center' | 'left' | 'right',
    });

    // Responsiveness.
    const anchor = getAnchorPlugin(this.scene);
    if (anchor) {
      switch (this.side) {
        case 'left':
          this.duelistHealthBar.setOrigin(0, 0);
          this.mainContainer.setPosition(16, this.mainContainer.y);
          anchor.add(this, {
            left: '0%',
          });
          break;
        case 'right':
          this.duelistHealthBar.setOrigin(1, 0);
          this.duelistHealthBar.setPosition(0, 0);
          this.mainContainer.setPosition(-16, this.mainContainer.y);
          anchor.add(this, {
            right: '100%',
          });
          break;
      }
    }

    for (var i = 0; i < duelist.maxHP; i++) {
      const newHeart = new HeartContainer(this.scene, 0, 0);
      this.heartContainer.add(newHeart);
      this.hearts[i] = newHeart;
    }
    this.layoutGroup.updateLayout();

    EventsManager.registerEventOn(
      this.scene,
      GAME_EVENTS.SET_ACTIVE,
      this.refresh,
      this,
    );
    EventsManager.registerEventOn(
      this.scene,
      GAME_EVENTS.DUELIST_PERFORMED_RIPOSTE,
      this.refresh,
      this,
    );
    this.scene.events.on('shutdown', this.handleShutdown, this);
  }

  refresh() {
    if (this.duelistUIData === null) return;
    const { duelist } = this.duelistUIData;
    this.hearts.forEach((heart, index) => {
      heart.setVisible(index < duelist.currHP);
    });
  }

  handleValidWord() {
    if (this.duelistUIData === null) return;
    const { duelist } = this.duelistUIData;
    EventBus.emit(GAME_EVENTS.SET_ACTIVE, duelist);
  }

  handleShutdown() {
    this.duelistUIData = null;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
